<script setup>
import TranslationProvider from '@/provider/translations.js'
import { onMounted, ref } from 'vue'
import { getCategories } from '@/components/CMB/general/utils.js'
import { useFiltersStore } from '@/services/store.js'

const filtersStore = useFiltersStore()

const props = defineProps({
  pageType: {
    type: String,
    default: 'compiled-poll-list'
  }
})

const search = ref("")
const categories = ref([])
const loading = ref(true)

onMounted(async () => {
  categories.value = await getCategories();
  loading.value = false
})

</script>

<template>
  <label for="main_contractor" class="form-label">
    {{ TranslationProvider.getTrans('app.tipo_impostazione') }}
  </label>
  <v-select
    id="main_contractor"
    v-model="filtersStore.filters[props.pageType]['gec_category_codes']"
    :options="categories"
    :filterable="true"
    :loading
    @search:blur="() => {}"
    @search:selected="() => {}"
    :placeholder="TranslationProvider.getTrans('app.tipo_impostazione')"
    :reduce="(cat) => cat.key"
    clearable
    multiple
    :selectable="(option) => {return !filtersStore.filters['gec_category_codes'] || !filtersStore.filters['gec_category_codes'].includes(option.key)}"
  >
    <template v-slot:no-options>
      <span v-if="search.length >= 3">
         {{ TranslationProvider.getTrans('app.no_result_found') }}
      </span>
      <span v-else>
         {{ TranslationProvider.getTrans('app.digita_per_cercare') }}
      </span>
    </template>
  </v-select>
</template>

<style scoped lang="scss">

</style>
